import { Config } from '../core/config'
import { model } from '../core/model'

const handleErrors = (response) => {
    return new Promise((resolve, reject) => {

        if (response.ok) {
            resolve(response)
        }
        else {
            switch (response.status) {
                case 500:
                    break;
                case 400:
                    break;
                case 401:
                    break;
                case 402:
                    break;
                case 403:
                    break;
                case 200:
                    ///
                    break;
                case 'parsererror':
                    break;
                case 'timeout':
                    break;
                case 'abort':
                    break;
                case 0:
                    break;
                default:
                    console.error('FalloHandler | No existe el error ( ' + response.status + ')');
            }
            reject(response.statusText)
        }
    });
}

const post = (url, body) => {
    //console.log('IMPORTED',model.ProductCategory)
    model.Usuario.updateToken();
    try {
        console.log(`${Config.apiPaywallUrl}` + url);
        return fetch(`${Config.apiPaywallUrl}` + url, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'X-Token': model.Usuario.xToken
            },
        })
            .then(handleErrors)
            .then(response => {
                return response.json()
            })
           
    }
    catch (ex) {
        console.log(ex);
    }

}


module.exports = {
    post
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/services/api.js